import { getDateNoTime } from '@assets/js/dateUtilsTwo';

const formatNotificationTime = value => {
  if (!value && value !== 0) return '暂无';
  const timestamp = Number(value);
  const normalizedTimestamp = String(Math.abs(timestamp)).length === 10 ? timestamp * 1000 : timestamp;
  return getDateNoTime(normalizedTimestamp);
};

export const tableProperties = [
  { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
  // { label: '国内咨询单号', prop: 'domestic_consultation_form_no', itemType: 'input', input: true, sortable: false, labelWidth: 140 },
  { label: '客户简称', prop: 'cust_abbr', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '客户货号', prop: 'cust_item_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '我司货号', prop: 'our_item_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '业务部门', prop: 'busi_dept_name', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '外销员', prop: 'sale_stff_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '打样单号', prop: 'sample_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '品名', prop: 'item_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '订单数量', prop: 'order_qty', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '单位', prop: 'unit', itemType: 'input', input: false, sortable: false, labelWidth: 100 },
  { label: '包装方式', prop: 'packing_method', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  {
    label: '通知时间',
    prop: 'notification_time',
    itemType: 'date',
    input: false,
    sortable: false,
    labelWidth: 120,
    formatter: val => formatNotificationTime(val)
  },
  { label: '状态', prop: 'display_status', itemType: 'input', input: false, sortable: false, labelWidth: 140 },
  { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false, labelWidth: 120 }
];
